import esES from "./es-ES";
export default {
  "es-ES": esES
};